import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useAppSelector } from "@/hooks/reducer-hooks";

export function HelpSupport() {
  const user = useAppSelector((state) => state.user);
  const hasVoucherPromotion =
    user.subscriptionPromotions?.some((promotion) => promotion.isVoucher) || false;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Help & Support</CardTitle>
        <CardDescription>
          Find answers to common questions or contact our support team.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Accordion type="single" collapsible>
          {hasVoucherPromotion && (
            <>
              <AccordionItem value="voucher-1">
                <AccordionTrigger>
                  Which resident email should I use to apply the voucher?
                </AccordionTrigger>
                <AccordionContent>
                  To apply the voucher, you need to use the email associated with resident's current
                  TULU account. If they do not yet have a TULU account, please use the email they
                  plan to sign up with.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="voucher-2">
                <AccordionTrigger>
                  What happens if a resident already has an active TULU subscription?
                </AccordionTrigger>
                <AccordionContent>
                  If a resident already has an active subscription, the free months will be added on
                  top of their current plan.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="voucher-3">
                <AccordionTrigger>
                  What if a resident does not yet have a TULU account?
                </AccordionTrigger>
                <AccordionContent>
                  Once the resident signs up for TULU using the email linked to the voucher, the
                  free months will be automatically applied.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="voucher-4">
                <AccordionTrigger>What is included in the Voucher Membership?</AccordionTrigger>
                <AccordionContent>
                  <p>The benefits remain the same for both 3-month and 6-month vouchers:</p>
                  <ul className="list-disc pl-6 mt-2">
                    <li>Free unlimited rentals for set hour</li>
                    <li>Access to shop with year round promotions, benefits and flash sales</li>
                    <li>Access to print</li>
                  </ul>
                </AccordionContent>
              </AccordionItem>
            </>
          )}
          <AccordionItem value="item-1">
            <AccordionTrigger>How do I format my CSV file?</AccordionTrigger>
            <AccordionContent>
              Your CSV file should have the following column: email. Each row should represent a
              single resident. Make sure the first row contains the column headers.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-2">
            <AccordionTrigger>What happens if I upload duplicate emails?</AccordionTrigger>
            <AccordionContent>
              If you choose Add to Existing List, duplicate emails will be ignored. If you choose
              Replace Existing List, the new data will overwrite any existing entries with the same
              email.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-3">
            <AccordionTrigger>What if I have any other question or complaint?</AccordionTrigger>
            <AccordionContent>
              We offer 24/7 Customer Support Service through our app by pressing "Contact us" or
              email support@tulu.io for users. If you need any management support, please reach out
              to yael@tulu.io
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </CardContent>
      <CardFooter>
        <Button onClick={() => (window.location.href = "mailto:support@tulu.io")}>
          Contact Support
        </Button>
      </CardFooter>
    </Card>
  );
}
